module.exports = __webpack_public_path__ + "static/reznickova-63d459fff8fcbfc247f1d18d5ecf65e8.jpg";